import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { ComposeComponent } from './compose.component';

import { HeaderModule } from './components/header';
import { SurveyTitleModule } from './components/survey-title';
import { QuestionCheckboxModule, QuestionRadioModule, QuestionTableCheckboxModule, QuestionTextModule, QuestionAfterschoolModule } from './components/questions'; 
import { FocusItemModule, QuestionTagsModule, NavBarModule, SurveyDataResolve } from '../shared';
import { LoadingModule } from '@schoolbelle/common/loading';

@NgModule({
  imports: [
    CommonModule,
    HeaderModule,
    SurveyTitleModule,
    QuestionCheckboxModule, QuestionRadioModule, QuestionTableCheckboxModule, QuestionTextModule, QuestionAfterschoolModule,
    QuestionTagsModule,
    FocusItemModule,
    LoadingModule.forRoot(),
    // NavBarModule,
  ],
  providers:[SurveyDataResolve],
  exports:[
    CommonModule,
    HeaderModule,
    SurveyTitleModule,
    QuestionCheckboxModule, QuestionRadioModule, QuestionTableCheckboxModule, QuestionTextModule, QuestionAfterschoolModule,
    QuestionTagsModule,
    FocusItemModule,
    LoadingModule,
    // NavBarModule,
  ],
  declarations: [ComposeComponent],
})
export class ComposeModule { }
